import { useUserIsSetupCorrectly } from "@hooks/useUserIsSetupCorrectly";
import { Alert } from "@mui/joy";

export function IncorrectUserConfigCheck() {
    const isSetupCorrectly = useUserIsSetupCorrectly();

    return isSetupCorrectly ? null : (
        <Alert variant="soft" color="danger" sx={{borderRadius: 0, justifyContent: 'center'}}>
            <span>
                Your user account does not have an associated contact which will cause issues. <a href="https://www.maestrocm.com/support/" target="_blank">Contact Maestro Support</a>
            </span>
        </Alert>
    );
}
